// client/src/pages/settings/BrandSettings.jsx
// VIP 贴牌页: 代理/被授权用户在左下角"页面风格"进入, 自定义自己的标题和背景
import React from 'react';
import { motion } from 'framer-motion';
import { FiStar } from 'react-icons/fi';

import BrandPanel from '../../components/settings/BrandPanel';
import { useAuth } from '../../context/AuthContext';

const BrandSettings = () => {
  const { isVip } = useAuth();

  // 路由层已拦(仅登录可达), 这里双保险: 非VIP(被撤权限)不给进
  if (!isVip) {
    return (
      <div className="flex flex-col items-center justify-center h-full">
        <div className="text-yellow-500 text-xl mb-4">无权访问</div>
        <p className="text-[#656d76]">贴牌功能为 VIP 权益, 请联系平台管理员开通菜单权限</p>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="h-full"
    >
      {/* 页面标题 */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-[#1f2328] flex items-center gap-2">
          贴牌设置
          <span className="px-2 py-0.5 text-xs rounded-full bg-[#fff8c5] text-[#9a6700] flex items-center">
            <FiStar className="mr-1" /> VIP
          </span>
        </h1>
        <p className="text-[#656d76] mt-1">
          自定义您的品牌标题和背景图(仅您自己登录后可见, 不影响平台其他用户)
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6">
        <div className="bg-white rounded-md shadow-sm p-6">
          <h2 className="text-lg font-semibold text-[#1f2328] mb-6 flex items-center">
            <FiStar className="mr-2 text-[#d4a72c]" /> 我的贴牌
          </h2>
          <BrandPanel />
        </div>
      </div>
    </motion.div>
  );
};

export default BrandSettings;
